import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const sharedProps = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: false
} as const;

export function ArrowLeftIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="m15 18-6-6 6-6" />
    </svg>
  );
}

export function CardsIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <rect x="6" y="3" width="13" height="17" rx="2" />
      <path d="M6 7 3.8 8.2a2 2 0 0 0-.8 2.7l4.5 8" />
      <path d="M10 8h5M10 12h5" />
    </svg>
  );
}

export function CheckIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="m5 12 4 4L19 6" />
    </svg>
  );
}

export function GlobeIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
    </svg>
  );
}

export function HistoryIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
      <path d="M3 3v5h5M12 7v5l3 2" />
    </svg>
  );
}

export function LockIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <rect x="5" y="10" width="14" height="10" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v2" />
    </svg>
  );
}

export function SparkIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="m12 3 1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3Z" />
      <path d="m18 15 .8 2.2L21 18l-2.2.8L18 21l-.8-2.2L15 18l2.2-.8L18 15Z" />
    </svg>
  );
}

export function XIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="m6 6 12 12M18 6 6 18" />
    </svg>
  );
}

export function HelpIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.2 9.3a2.8 2.8 0 0 1 5.3 1c0 1.9-2.7 2.4-2.7 4" />
      <path d="M12 17.4h.01" />
    </svg>
  );
}

export function ShuffleIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M18 4l3 3-3 3M18 14l3 3-3 3" />
      <path d="M3 7h4.5a4 4 0 0 1 3.4 1.9M3 17h4.5a4 4 0 0 0 3.4-1.9M14.5 7H21M14.5 17H21" />
    </svg>
  );
}

export function EyeIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
      <circle cx="12" cy="12" r="2.6" />
    </svg>
  );
}

export function EyeOffIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M10.6 6.7A9.7 9.7 0 0 1 12 6.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-2.9 3.5M6.4 8.4A17 17 0 0 0 2.5 13S6 19.5 12 19.5a9.4 9.4 0 0 0 3.4-.6" />
      <path d="M9.9 10.3a2.6 2.6 0 0 0 3.7 3.7M3 3l18 18" />
    </svg>
  );
}

export function MegaphoneIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M3 11v2a1 1 0 0 0 1 1h2l4.5 3.5a1 1 0 0 0 1.6-.8V6.3a1 1 0 0 0-1.6-.8L6 9H4a1 1 0 0 0-1 1Z" />
      <path d="M15 8.5a4 4 0 0 1 0 7M6 14v3.5a1.5 1.5 0 0 0 3 0V15.6" />
    </svg>
  );
}

export function ChevronDownIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}

export function DrawCardIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <rect x="4" y="3" width="12" height="16" rx="2" />
      <path d="M20 8v11a2 2 0 0 1-2 2H9" />
      <path d="M10 9v5m0 0 2.2-2.2M10 14l-2.2-2.2" />
    </svg>
  );
}

export function PresentIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M8 4H5a1 1 0 0 0-1 1v3M16 4h3a1 1 0 0 1 1 1v3M8 20H5a1 1 0 0 1-1-1v-3M16 20h3a1 1 0 0 0 1-1v-3" />
    </svg>
  );
}

export function FilmIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M8 4v16M16 4v16M3 9h5M3 15h5M16 9h5M16 15h5" />
    </svg>
  );
}
